{
  "allTasks.nav": "كل المهام",
  "allTasks.title": "كل المهام",
  "allTasks.subtitle": "شغل كل المشاريع على لوحة واحدة. ضيّقها بالفلاتر.",
  "allTasks.loadError": "لم نتمكن من تحميل المهام.",
  "allTasks.empty.title": "لا مهام بعد",
  "allTasks.empty.body": "المهام المضافة لأي مشروع تظهر هنا.",
  "allTasks.capped": "نعرض أول {count} مهمة. ضيّق الفلاتر لترى الباقي.",
  "allTasks.quick.label": "عروض سريعة",
  "allTasks.quick.mine": "مهامي",
  "allTasks.quick.unassigned": "من غير مسؤول",
  "allTasks.quick.overdue": "متأخرة",
  "allTasks.quick.week": "مستحقة هذا الأسبوع",
  "allTasks.quick.blocked": "معطّلة",
  "allTasks.filters.label": "الفلاتر",
  "allTasks.filters.project": "المشروع",
  "allTasks.filters.projectSearch": "ابحث في المشاريع",
  "allTasks.filters.client": "العميل",
  "allTasks.filters.clientSearch": "ابحث في العملاء",
  "allTasks.filters.internal": "مشاريع داخلية",
  "allTasks.filters.assignee": "المسؤول",
  "allTasks.filters.priority": "الأولوية",
  "allTasks.filters.prioritySearch": "ابحث في الأولويات",
  "allTasks.filters.due": "الاستحقاق",
  "allTasks.filters.labels": "الوسوم",
  "allTasks.filters.noMatch": "لا شيء مطابق.",
  "allTasks.filters.selected": "{count, plural, zero {لا شيء محدد} one {واحد محدد} two {اثنان محددان} few {# محددة} many {# محددًا} other {# محدد}}",
  "allTasks.filters.clear": "مسح",
  "allTasks.filters.clearOne": "مسح {filter}",
  "allTasks.filters.clearAll": "مسح الكل",
  "allTasks.due.overdue": "متأخرة",
  "allTasks.due.today": "اليوم",
  "allTasks.due.week": "هذا الأسبوع",
  "allTasks.due.next7": "الأيام السبعة القادمة",
  "allTasks.due.none": "بدون موعد",
  "allTasks.due.custom": "فترة مخصصة",
  "work.you": "أنت",
  "work.searchPeople": "ابحث عن شخص",
  "work.noPeopleMatch": "لا يوجد أحد مطابق.",
  "work.notSet": "غير محدد",
  "health.status.on_track": "على المسار",
  "health.status.at_risk": "معرّض للتأخر",
  "health.status.off_track": "متعثّر",
  "health.status.paused": "متوقف",
  "health.finding.past_due": "تجاوز تاريخ انتهائه {count, plural, zero {اليوم} one {بيوم واحد} two {بيومين} few {بـ# أيام} many {بـ# يومًا} other {بـ# يوم}}",
  "health.finding.due_soon": "ينتهي {count, plural, zero {اليوم} one {غدًا} two {بعد يومين} few {بعد # أيام} many {بعد # يومًا} other {بعد # يوم}} ومعظم العمل لم يُنجز بعد",
  "health.finding.overdue_tasks": "{count, plural, zero {لا توجد مهام متأخرة} one {مهمة واحدة متأخرة} two {مهمتان متأخرتان} few {# مهام متأخرة} many {# مهمة متأخرة} other {# مهمة متأخرة}}",
  "health.finding.stale": "لم يتحرك شيء منذ {count, plural, zero {اليوم} one {يوم واحد} two {يومين} few {# أيام} many {# يومًا} other {# يوم}}",
  "health.finding.late_milestones": "{count, plural, zero {لا محطات متأخرة} one {محطة واحدة متأخرة} two {محطتان متأخرتان} few {# محطات متأخرة} many {# محطة متأخرة} other {# محطة متأخرة}}",
  "projects.internal": "داخلي",
  "projects.noLead": "بلا مسؤول",
  "projects.columns.lead": "المسؤول",
  "projects.columns.health": "سير العمل",
  "projects.columns.overdue": "متأخرة",
  "projects.statusFilter.label": "التصفية حسب الحالة",
  "projects.statusFilter.open": "المفتوحة",
  "projects.statusFilter.on_hold": "المعلّقة",
  "projects.statusFilter.completed": "المكتملة",
  "projects.statusFilter.archived": "المؤرشفة",
  "projects.statusFilter.all": "الكل",
  "projects.filter.allServices": "كل الخدمات",
  "projects.filter.option": "{label} ({count})",
  "projects.filter.client": "التصفية حسب العميل",
  "projects.filter.allClients": "كل العملاء",
  "projects.filter.clientSearch": "ابحث عن عميل",
  "projects.filter.clientEmpty": "لا يوجد عميل مطابق.",
  "projects.emptyMember.title": "لم تتم إضافتك إلى أي مشروع بعد",
  "projects.emptyMember.body": "عندما يضيفك مسؤول أحد المشاريع إليه، سيظهر المشروع هنا.",
  "projects.emptyStatus.on_hold": "لا توجد مشاريع معلّقة",
  "projects.emptyStatus.completed": "لا توجد مشاريع مكتملة بعد",
  "projects.emptyStatus.archived": "لا توجد مشاريع مؤرشفة",
  "projects.emptyStatus.all": "لا توجد مشاريع بعد",
  "projects.emptyStatus.body": "تظهر المشاريع هنا عندما تتغير حالتها.",
  "projects.stats.overdue": "مهام متأخرة",
  "projects.stats.attention": "{count, plural, zero {كلها تسير وفق الخطة} one {مشروع واحد يحتاج إلى متابعة} two {مشروعان يحتاجان إلى متابعة} few {# مشاريع تحتاج إلى متابعة} many {# مشروعًا يحتاج إلى متابعة} other {# مشروع يحتاج إلى متابعة}}",
  "newProject.client": "العميل",
  "newProject.noClient": "بدون عميل (مشروع داخلي)",
  "newProject.clientSearch": "ابحث عن عميل",
  "newProject.clientEmpty": "لا يوجد عميل مطابق.",
  "newProject.lead": "مسؤول المشروع",
  "newProject.leadPlaceholder": "اختر مسؤول المشروع",
  "newProject.startsOn": "تاريخ البدء",
  "newProject.dueOn": "تاريخ الانتهاء",
  "newProject.descriptionLabel": "الوصف",
  "newProject.descriptionPlaceholder": "ما الغرض من هذا المشروع؟ الأهداف والنطاق والروابط المفيدة.",
  "newProject.errors.dueBeforeStart": "لا يمكن أن يسبق تاريخ الانتهاء تاريخ البدء.",
  "project.internal": "مشروع داخلي",
  "project.schedule": "الجدول الزمني",
  "project.dates": "{start} – {end}",
  "project.dueOn": "ينتهي في {date}",
  "project.startsOn": "يبدأ في {date}",
  "project.tabs.list": "القائمة",
  "project.tabs.members": "الأعضاء",
  "project.tabs.settings": "الإعدادات",
  "project.archived.title": "هذا المشروع مؤرشف",
  "project.archived.body": "المشروع للقراءة فقط. تواصل مع مسؤوله إذا لزمت استعادته.",
  "project.archived.bodyManager": "المشروع للقراءة فقط. استعده لتتمكن من تخطيط المهام وتعديلها من جديد.",
  "project.archived.restore": "استعادة المشروع",
  "project.archived.restored": "تمت استعادة المشروع.",
  "projectRole.lead": "مسؤول",
  "projectRole.contributor": "مساهم",
  "projectRole.viewer": "مُشاهد",
  "overview.health.title": "سير المشروع",
  "overview.health.onTrack": "كل شيء يسير وفق الخطة.",
  "overview.health.paused": "المشروع معلّق، لذا توقفت متابعة سيره مؤقتًا.",
  "overview.health.closed": "تتم متابعة سير المشروع ما دام نشطًا.",
  "overview.health.completedOn": "اكتمل في {date}.",
  "overview.members.title": "الأعضاء",
  "overview.members.manage": "إدارة",
  "overview.members.all": "عرض الكل",
  "overview.members.openTasks": "{count, plural, zero {لا مهام مفتوحة} one {مهمة مفتوحة واحدة} two {مهمتان مفتوحتان} few {# مهام مفتوحة} many {# مهمة مفتوحة} other {# مهمة مفتوحة}}",
  "overview.members.more": "{count, plural, zero {لا أعضاء آخرون} one {وعضو آخر} two {وعضوان آخران} few {و# أعضاء آخرين} many {و# عضوًا آخر} other {و# عضو آخر}}",
  "members.loadError": "تعذّر تحميل الأعضاء.",
  "members.description": "يدير المسؤول المشروع وفريقه، ويخطط المساهمون للعمل وينفذونه، ويتابع المشاهدون دون تعديل.",
  "members.readOnly": "يستطيع مسؤول المشروع والمشرفون فقط تغيير أعضاء المشروع.",
  "members.add": "إضافة عضو",
  "members.adding": "جارٍ الإضافة…",
  "members.addPerson": "الشخص المراد إضافته",
  "members.addPlaceholder": "اختر عضوًا من الفريق",
  "members.addNobody": "كل أعضاء الفريق مضافون إلى هذا المشروع بالفعل.",
  "members.addRole": "الدور في المشروع",
  "members.added": "تمت إضافة {name} إلى المشروع.",
  "members.roleOf": "دور {name} في المشروع",
  "members.roleChanged": "تم تحديث دور {name}.",
  "members.youAndRole": "أنت · {role}",
  "members.leadHint": "لنقل مسؤولية المشروع، عيّن عضوًا آخر مسؤولًا.",
  "members.remove": "إزالة {name}",
  "members.removeTitle": "إزالة {name} من المشروع؟",
  "members.removeBody": "{count, plural, zero {لا توجد مهام مفتوحة مُسندة إليه هنا.} one {ستصبح مهمته المفتوحة الوحيدة غير مُسندة.} two {ستصبح مهمتاه المفتوحتان غير مُسندتين.} few {ستصبح مهامه المفتوحة الـ# غير مُسندة.} many {ستصبح مهامه المفتوحة الـ# غير مُسندة.} other {ستصبح مهامه المفتوحة الـ# غير مُسندة.}} يمكنك إضافته مجددًا في أي وقت.",
  "members.removeConfirm": "إزالة",
  "members.removing": "جارٍ الإزالة…",
  "members.removed": "تمت إزالة {name}. {count, plural, zero {لم تكن هناك مهام تحتاج إلى إعادة إسناد.} one {أصبحت مهمة واحدة غير مُسندة.} two {أصبحت مهمتان غير مُسندتين.} few {أصبحت # مهام غير مُسندة.} many {أصبحت # مهمة غير مُسندة.} other {أصبحت # مهمة غير مُسندة.}}",
  "members.makeLeadTitle": "تعيين {name} مسؤولًا عن المشروع؟",
  "members.makeLeadBody": "سيصبح {previous} مساهمًا. يدير المسؤول المشروع وأعضاءه وإعداداته.",
  "members.makeLeadConfirm": "تعيينه مسؤولًا",
  "members.errors.alreadyMember": "هذا الشخص عضو في المشروع بالفعل.",
  "members.errors.lastLead": "لا بد للمشروع من مسؤول. عيّن شخصًا آخر مسؤولًا أولًا.",
  "members.errors.notStaff": "يمكن إضافة أعضاء الفريق النشطين فقط إلى المشروع.",
  "settings.details.title": "تفاصيل المشروع",
  "settings.save": "حفظ التغييرات",
  "settings.saving": "جارٍ الحفظ…",
  "settings.saved": "تم حفظ التغييرات.",
  "settings.discard": "تجاهل التغييرات",
  "settings.conflict.title": "عدّل شخص آخر هذا المشروع",
  "settings.conflict.body": "حمّل تعديلاته أولًا، ثم أعد إجراء تعديلاتك.",
  "settings.conflict.reload": "تحميل أحدث نسخة",
  "settings.errors.archived": "لا يمكن تعديل المشاريع المؤرشفة. استعد المشروع أولًا.",
  "settings.errors.transition": "لا يمكن إجراء هذا التغيير من الحالة الحالية.",
  "settings.status.title": "الحالة",
  "settings.status.about.active": "العمل جارٍ وتتم متابعة سير المشروع.",
  "settings.status.about.on_hold": "معلّق. تتوقف متابعة سيره حتى استئنافه.",
  "settings.status.about.completed": "تم التسليم. أعد فتحه إذا استجد عمل.",
  "settings.status.about.archived": "مخفي من قائمة المشاريع وللقراءة فقط.",
  "settings.action.hold": "تعليق المشروع",
  "settings.action.resume": "استئناف المشروع",
  "settings.action.complete": "تحديده مكتملًا",
  "settings.action.reopen": "إعادة فتح المشروع",
  "settings.action.archive": "أرشفة",
  "settings.action.restore": "استعادة",
  "settings.confirm.archive.title": "أرشفة {name}؟",
  "settings.confirm.archive.body": "سيختفي من قائمة المشاريع ويصبح للقراءة فقط. يمكنك استعادته في أي وقت.",
  "settings.confirm.archive.confirm": "أرشفة المشروع",
  "settings.confirm.complete.title": "تحديد {name} مكتملًا؟",
  "settings.confirm.complete.body": "ستتوقف متابعة سيره، وتبقى المهام المفتوحة كما هي، ويمكنك إعادة فتح المشروع لاحقًا.",
  "settings.confirm.complete.confirm": "تحديده مكتملًا",
  "settings.statusChanged": "تغيّرت الحالة إلى «{status}».",
  "settings.forbidden.title": "يستطيع المسؤول والمشرفون فقط تغيير الإعدادات",
  "settings.forbidden.body": "تواصل مع مسؤول المشروع إذا لزم تغيير شيء.",
  "board.collapse": "طيّ عمود {column}",
  "board.expand": "توسيع عمود {column}",
  "board.done.olderHidden": "{count, plural, zero {لا مهام} one {مهمة واحدة} two {مهمتان} few {# مهام} many {# مهمة} other {# مهمة}} أُنجزت قبل أكثر من {days, number} يومًا",
  "board.done.showAll": "عرض الكل في القائمة",
  "board.addError.generic": "لم تُضَف المهمة. حاول مرة أخرى.",
  "board.addError.archived": "المشروع مؤرشف، لذا لا يمكن إضافة مهام.",
  "priority.none": "بلا أولوية",
  "priority.low": "منخفضة",
  "priority.medium": "متوسطة",
  "priority.high": "عالية",
  "priority.urgent": "عاجلة",
  "priority.label": "الأولوية: {priority}",
  "task.assignedTo": "مُسندة إلى {name}",
  "task.due.label": "تستحق في {date}",
  "task.due.overdueLabel": "متأخرة، كانت تستحق في {date}",
  "task.due.overdue": "متأخرة",
  "task.due.today": "اليوم",
  "task.due.tomorrow": "غدًا",
  "task.due.yesterday": "أمس",
  "task.description": "الوصف",
  "task.descriptionPlaceholder": "أضف وصفًا…",
  "task.descriptionEmpty": "لا يوجد وصف.",
  "task.editDescription": "تعديل الوصف",
  "task.assignee": "المُسند إليه",
  "task.unassigned": "غير مُسندة",
  "task.assigneeSearch": "ابحث في الأعضاء",
  "task.assignees": "المُسند إليهم",
  "task.editAssignees": "تغيير المُسند إليهم",
  "task.assigneesFull": "تتسع المهمة لـ{count, number} أشخاص على الأكثر.",
  "task.moreAssignees": "+{count, number}",
  "task.priority": "الأولوية",
  "task.startsOn": "تاريخ البدء",
  "task.dueOn": "تاريخ الاستحقاق",
  "task.clearDate": "مسح {field}",
  "task.estimate": "الوقت المقدّر",
  "task.estimateHours": "الساعات",
  "task.estimateMinutes": "الدقائق",
  "task.estimateHoursUnit": "س",
  "task.estimateMinutesUnit": "د",
  "task.estimateValue": "{hours, number} س {minutes, number} د",
  "task.estimateHoursOnly": "{hours, number} س",
  "task.estimateMinutesOnly": "{minutes, number} د",
  "task.noEstimate": "بلا تقدير",
  "task.createdBy": "أنشأها",
  "task.loadError": "تعذّر تحميل هذه المهمة.",
  "task.cancelledNotice": "أُلغيت هذه المهمة. تبقى محفوظة للرجوع إليها ولا تظهر على اللوحة.",
  "task.readOnly": "يمكنك عرض هذه المهمة دون تعديلها.",
  "task.archivedProject": "المشروع مؤرشف، لذا مهامه للقراءة فقط.",
  "task.cancel.action": "إلغاء المهمة",
  "task.cancel.title": "إلغاء {reference}؟",
  "task.cancel.body": "ستختفي من اللوحة ولن تُحتسب في نسبة الإنجاز. يمكنك استعادتها لاحقًا من القائمة.",
  "task.cancel.confirm": "إلغاء المهمة",
  "task.cancel.keep": "الإبقاء على المهمة",
  "task.cancel.done": "أُلغيت المهمة {reference}.",
  "task.restore.action": "استعادة المهمة",
  "task.restore.title": "استعادة {reference}؟",
  "task.restore.body": "ستعود إلى نهاية عمود «للتنفيذ».",
  "task.restore.confirm": "استعادة المهمة",
  "task.restore.done": "استُعيدت المهمة {reference}.",
  "taskList.columns.status": "الحالة",
  "taskList.columns.reference": "الرقم",
  "taskList.columns.title": "العنوان",
  "taskList.columns.assignee": "المُسند إليه",
  "taskList.columns.priority": "الأولوية",
  "taskList.columns.due": "الاستحقاق",
  "taskList.columns.updated": "آخر تحديث",
  "taskList.sortBy": "الترتيب حسب {column}",
  "taskList.sort.label": "الترتيب",
  "taskList.sort.updated": "الأحدث تحديثًا",
  "taskList.sort.due": "تاريخ الاستحقاق",
  "taskList.sort.priority": "الأولوية",
  "taskList.sort.created": "الأحدث إنشاءً",
  "taskList.sort.number": "الرقم",
  "taskList.filters.search": "ابحث في المهام",
  "taskList.filters.status": "التصفية حسب الحالة",
  "taskList.filters.assignee": "التصفية حسب المُسند إليه",
  "taskList.filters.anyone": "أي شخص",
  "taskList.filters.me": "أنا",
  "taskList.filters.priority": "التصفية حسب الأولوية",
  "taskList.filters.anyPriority": "أي أولوية",
  "taskList.filters.due": "الاستحقاق",
  "taskList.filters.dueAfter": "مستحقة من",
  "taskList.filters.dueBefore": "مستحقة حتى",
  "taskList.filters.clear": "مسح عوامل التصفية",
  "taskList.count": "{count, plural, zero {لا مهام} one {مهمة واحدة} two {مهمتان} few {# مهام} many {# مهمة} other {# مهمة}}",
  "taskList.loadMore": "تحميل المزيد",
  "taskList.loadingMore": "جارٍ التحميل…",
  "taskList.empty.title": "لا توجد مهام بعد",
  "taskList.empty.body": "تظهر هنا المهام التي تُضاف على اللوحة.",
  "taskList.noResults.title": "لا توجد مهام مطابقة",
  "taskList.noResults.body": "جرّب عوامل تصفية أخرى، أو امسحها لعرض كل المهام.",
  "taskList.loadError": "تعذّر تحميل المهام.",
  "taskList.noDate": "—",
  "projects.view.label": "عرض المشاريع",
  "projects.view.list": "قائمة",
  "projects.view.grid": "بطاقات",
  "projects.columns.dates": "المدة",
  "projects.columns.tasks": "المهام",
  "projects.tasks.open": "{count, plural, zero {لا مهام مفتوحة} one {مهمة مفتوحة} two {مهمتان مفتوحتان} few {# مهام مفتوحة} many {# مهمة مفتوحة} other {# مهمة مفتوحة}}",
  "projects.tasks.overdue": "{count, plural, zero {لا متأخرة} one {متأخرة واحدة} two {متأخرتان} few {# متأخرة} many {# متأخرة} other {# متأخرة}}",
  "projects.dates.noEnd": "بلا تاريخ انتهاء",
  "projects.dates.ends": "ينتهي {date}",
  "projects.members": "{count, plural, zero {لا أعضاء} one {عضو واحد} two {عضوان} few {# أعضاء} many {# عضوًا} other {# عضو}}",
  "projects.stats.attentionNone": "كلها على المسار",
  "project.pulse.label": "المشروع في لمحة",
  "project.pulse.done": "منجز",
  "project.pulse.open": "{count, plural, zero {مهام مفتوحة} one {مهمة مفتوحة} two {مهمتان مفتوحتان} few {مهام مفتوحة} many {مهمة مفتوحة} other {مهمة مفتوحة}}",
  "project.pulse.daysLeft": "{count, plural, zero {ينتهي اليوم} one {يوم متبقٍ} two {يومان متبقيان} few {أيام متبقية} many {يومًا متبقيًا} other {يوم متبقٍ}}",
  "project.pulse.daysLate": "{count, plural, zero {متأخر} one {يوم تأخير} two {يوما تأخير} few {أيام تأخير} many {يومًا تأخيرًا} other {يوم تأخير}}",
  "board.column.empty": "لا مهام هنا",
  "board.column.dropHere": "أفلت مهمة هنا، أو أضف واحدة",
  "overview.health.check.past_due": "ضمن تاريخ الانتهاء",
  "overview.health.check.due_soon": "لا ينتهي ومعظم العمل مفتوح",
  "overview.health.check.overdue_tasks": "لا مهام متأخرة",
  "overview.health.check.stale": "العمل يتحرك مؤخرًا",
  "overview.health.check.late_milestones": "لا محطات متأخرة",
  "members.roles.title": "الأدوار في هذا المشروع",
  "members.roles.lead": "يدير المشروع: أعضاءه وخطته وإعداداته.",
  "members.roles.contributor": "يخطط وينفّذ العمل: المهام والملفات والوقت.",
  "members.roles.viewer": "يتابع ويعلّق دون تغيير العمل.",
  "members.roles.openWork": "{count, plural, zero {لا مهام مفتوحة مسندة} one {مهمة مفتوحة واحدة مسندة للفريق} two {مهمتان مفتوحتان مسندتان للفريق} few {# مهام مفتوحة مسندة للفريق} many {# مهمة مفتوحة مسندة للفريق} other {# مهمة مفتوحة مسندة للفريق}}",
  "task.placement.label": "في الخطة",
  "task.placement.projectOnly": "المشروع فقط (بلا محطة)",
  "task.placement.search": "ابحث في المحطات والمراحل",
  "task.placement.noMatch": "لا محطة أو مرحلة مطابقة.",
  "task.placement.path": "{milestone} ‹ {phase}",
  "taskList.filters.phase": "التصفية حسب المرحلة",
  "taskList.filters.anyPhase": "أي مرحلة",
  "taskList.filters.noPhase": "بلا مرحلة",
  "taskList.filters.phaseSearch": "ابحث في المراحل",
  "taskList.filters.noPhaseMatch": "لا مرحلة مطابقة."
}
